export const RegisterPageRoute = "/registrieren";
export const RegisterSuccessPageRoute = "/registrieren/erfolgreich";
export const PasswordForgottenRoute = "/passwort-vergessen";
export const PasswordResetRoute = "/passwort-zuruecksetzen";
export const LoginRoute = "/login";
export const LogoutRoute = "/logout";
export const OauthRedirectUrl = "/oauth_redirect";
export const Oauth2Url = "/oauth2";
